module.exports = {"id":"dp3_4l1q1","text":"Computational Thinking and Programming","instructions":"Which statement best describes the role of computer programs in society?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.4","questionType":"PickOne","random":true,"options":[{"id":"dp3_4l1q1-a1","text":"They automate tasks and support digital services","score":1.8},{"id":"dp3_4l1q1-a2","text":"They exist only for technical professionals","score":0},{"id":"dp3_4l1q1-a3","text":"They replace all human decision making","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.4/l1q1.json
// module id = 1175
// module chunks = 41